import React, { useEffect, useState } from "react";
import "../../assets/styles/local/DashBoard.css";
import { useDispatch, useSelector } from "react-redux";
import { FetchLast365InvoiceInsights } from "../../redux/actions/action";
import { europeanFormat } from "../../utils/European-Format/NumberFormatter";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const CashFlowCard = () => {
  const dispatch = useDispatch();

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  const last365InvoiceInsights = useSelector((state) => state.user.last365InvoiceInsights);

  useEffect(() => {
    fetchScreenTranslations("BI-Dashboard-List").then(data => setFetchTranslationList(data));
    dispatch(FetchLast365InvoiceInsights());
  }, []);

  return (
    <>
      <div className="cashflowCard cashflowCard_Res">
        <div className="cashTitle">
          <span>
            {/* Cashflow */}
            {t("CashFlow")}
          </span>
          <span> | </span>
          <span>
            {/* Last 365 Days */}
            {t("Last 365 Days")}
          </span>
        </div>
        <div className="cashDetails">
          <div className="cash">
            <text>
              {/* INVOICED */}
              {t("INVOICED")}
            </text>
            <div className="colorline" style={{ color: "#B0DD69" }}></div>
            <div>€ {europeanFormat(last365InvoiceInsights?.invoicedAmount || 0, 0)}</div>
            <text>{last365InvoiceInsights?.invoicedCount || 0} </text>
            <text>
              {/* Invoices */}
              {t("invoices")}
            </text>
          </div>
          <div className="cash">
            <text>
              {/* RECEIVED */}
              {t("RECEIVED")}
            </text>
            <div className="colorline" style={{ color: "#95A7C6" }}></div>
            <div>€ {europeanFormat(last365InvoiceInsights?.recievedAmount || 0, 0)}</div>
            <text>{last365InvoiceInsights?.recievedCount || 0} </text>
            <text>
              {/* Invoice */}
              {t("invoices")}
            </text>
          </div>
          <div className="cash">
            <text>
              {/* OVERDUE */}
              {t("OVERDUE")}
            </text>
            <div className="colorline" style={{ color: "#FF7E57" }}></div>
            <div>€ {europeanFormat(last365InvoiceInsights?.overdueAmount || 0, 0)}</div>
            <text>{last365InvoiceInsights?.overdueCount || 0} </text>
            <text>
              {/* Invoices */}
              {t("invoices")}
            </text>
          </div>
          <div className="cash">
            <text>
              {/* OPEN */}
              {t("OPEN")}
            </text>
            <div className="colorline" style={{ color: "#EFCB51" }}></div>
            <div>€ {europeanFormat(last365InvoiceInsights?.openAmount || 0, 0)}</div>
            <text>{last365InvoiceInsights?.openCount || 0} </text>
            <text>
              {/* Invoices */}
              {t("invoices")}
            </text>
          </div>
        </div>
      </div>
    </>
  );
};

export default CashFlowCard;
